<div class="notification-container">
    @for (notification of notifications; track notification.id) {
        <app-notification
            [code]="notification.code"
            [title]="notification.title"
            [description]="notification.description"
            [severity]="notification.severity"
            [showCloseButton]="notification.showCloseButton"
            [context]="notification.context"
            (closeClicked)="onClose(notification.id)"
        >
        </app-notification>
    }
</div>
